import Types from '../Types'
import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

export const INITIAL_STATE = Immutable({
  error: null,
  findAllAttempting: false,
  promocodes: [],
  pageCount: 0,
  findOneAttempting: false,
  promocode: {},
  addAttempting: false,
  saveAttempting: false
})

const ACTION_HANDLERS = {
  [Types.FIND_ALL_PROMOCODES_ATTEMPT]: (state, action) =>
    state.merge({ findAllAttempting: true }),
  [Types.FIND_ALL_PROMOCODES_SUCCESS]: (state, action) =>
    state.merge({
      findAllAttempting: false,
      promocodes: action.result.promocodes,
      pageCount: action.result.pageCount,
      error: null
    }),
  [Types.FIND_ALL_PROMOCODES_FAILURE]: (state, action) =>
    state.merge({ findAllAttempting: false, error: action.error }),

  [Types.FIND_ONE_PROMOCODE_ATTEMPT]: (state, action) =>
    state.merge({ findOneAttempting: true, promocode: {} }),
  [Types.FIND_ONE_PROMOCODE_SUCCESS]: (state, action) =>
    state.merge({
      findOneAttempting: false,
      promocode: action.result,
      error: null
    }),
  [Types.FIND_ONE_PROMOCODE_FAILURE]: (state, action) =>
    state.merge({ findOneAttempting: false, error: action.error }),

  [Types.ADD_PROMOCODE_ATTEMPT]: (state, action) =>
    state.merge({ addAttempting: true, addAttempted: false }),
  [Types.ADD_PROMOCODE_SUCCESS]: (state, action) => {
    window.location.href = `/admin/promocodes/${action.result.code}`
    return state.merge({
      addAttempting: false,
      addAttempted: false,
      promocode: action.result,
      error: null
    })
  },
  [Types.ADD_PROMOCODE_FAILURE]: (state, action) =>
    state.merge({ addAttempting: false, addAttempted: true, error: action.error }),

  [Types.SAVE_PROMOCODE_ATTEMPT]: (state, action) =>
    state.merge({ saveAttempting: true }),
  [Types.SAVE_PROMOCODE_SUCCESS]: (state, action) =>
    state.merge({
      saveAttempting: false,
      promocode: action.result,
      error: null
    }),
  [Types.SAVE_PROMOCODE_FAILURE]: (state, action) =>
    state.merge({ saveAttempting: false, error: action.error })
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



// WEBPACK FOOTER //
// ./src/redux/promocode/promocodeReducer.js